document.addEventListener("DOMContentLoaded", () => {
  const captchas = document.querySelectorAll(".captcha-wrapper")
  if (captchas.length) {
    captchas.forEach((captcha) => {
      const form = captcha.closest("form")
      // wait for the form to be focused to download the recaptcha js
      form.addEventListener(
        "focus",
        () => {
          const script = document.createElement("script")
          script.src = captcha.dataset.url
          script.async = "true"
          captcha.insertAdjacentElement("afterbegin", script)
        },
        { once: true, capture: true }
      );
    })
  }
})
